module.exports = __webpack_public_path__ + "static/img/3.905456f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/3.png
// module id = MkaG
// module chunks = 0